<template>
  <div class="page-wrapper">
    <div class="container-fluid h-100">
      <div class="row h-100">
        <div class="col-12 h-100 scroll-container horizontal-scrollable">
          <div class="container">
            <div class="row">
              <div class="col-4">
                <div class="container">
                  <div class="row">
                    <label class="col-4 form-control text-right">From:</label>
                    <input type="date" class="col-8 form-control" v-model="filter.from"/>
                  </div>
                  <div class="row">
                    <label class="col-4 form-control text-right">To:</label>
                    <input type="date" class="col-8 form-control" v-model="filter.to"/>
                  </div>
                </div>
              </div>
              <div class="col-2">
                <button type="button" class="btn btn-primary" v-on:click="getFilteredList">가져오기</button>
              </div>
              <div class="col-2">
                <button type="button" class="btn btn-primary" v-on:click="openPurchaseForm(-1)">구매 추가</button>
              </div>
            </div>


          </div>
          <table class="table">
            <tr class="purchase-table-header">
              <th>Date</th>
              <th>Receipt</th>
              <th>brand</th>
              <th>GROSS</th>
              <th>NET</th>
              <th>VAT</th>
              <th></th>
              <th></th>
              <th>#</th>
              <th></th>
              <th>Item</th>
              <th>Item parcel</th>
              <th>title on receipt</th>
              <th>Colour</th>
              <th>GROSS</th>
              <th>VAT</th>
              <th>NET</th>
              <th>원산지</th>
              <th>State</th>
              <th>판매가(원)</th>
              <th>AWB</th>
              <th>출발일</th>
              <th>HS</th>
              <th>수취인</th>
              <th>연락처</th>
              <th>Custom ID</th>
              <th>VALUE($)</th>
              <th>PostCode</th>
              <th class="text-left">Address</th>
              <th class="text-left">Address2</th>


              <th></th>
            </tr>
            <tbody v-for="(purchase, index) in purchaseItems" class="purchase-block">
              <tr>
                <td rowspan="100%"><input type="date" class="input-mid" v-model="purchase.purchasedTime" @change="updatePurchaseItem(purchase)"/></td>
                <td rowspan="100%"><span><i class="fas fa-receipt"></i></span><span><i class="fas fa-eye"></i></span></td>

                <td rowspan="100%"><input type="text" class="input-short" v-model="purchase.brand" @change="updatePurchaseItem(purchase)"/></td>
                <td rowspan="100%"><input type="number" class="text-right input-money" v-model="purchase.gross" @change="updatePurchaseItem(purchase)"/></td>
                <td rowspan="100%"><input type="number" class="text-right input-money" v-model="purchase.net" @change="updatePurchaseItem(purchase)"/></td>
                <td rowspan="100%"><input type="number" class="text-right input-money" v-model="purchase.vat" @change="updatePurchaseItem(purchase)"/></td>
                <td rowspan="100%"><span v-on:click="deletePurchaseItem(purchase)"><i class="fa fa-trash"></i></span></td>
                <td rowspan="100%"><span v-on:click="openStockForm(index, -1)"><i class="fa fa-plus"></i></span></td>

                <td v-if="purchase.list.length == 0">&nbsp;</td>
                <td v-if="purchase.list.length == 0">&nbsp;</td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>
                <td v-if="purchase.list.length == 0"></td>

                <td v-if="purchase.list.length > 0">#{{purchase.list[0].id}}</td>
                <td v-if="purchase.list.length > 0"><span v-on:click="printItem(purchase.list[0])"><i class="fa fa-barcode"></i></span></td>

                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-long" v-model="purchase.list[0].title" @keyup="checkSpecialCharacter(purchase.list[0])" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-long" v-model="purchase.list[0].titleToSend" @keyup="checkSpecialCharacter(purchase.list[0])"@change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-long" v-model="purchase.list[0].receiptItemTitle" @keyup="checkSpecialCharacter(purchase.list[0])"@change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-short" v-model="purchase.list[0].colour" @keyup="checkSpecialCharacter(purchase.list[0])" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0"><input type="number" class="text-right input-money" v-model="purchase.list[0].purchaseGross" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0"><input type="number" class="text-right input-money" v-model="purchase.list[0].purchaseVat" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0"><input type="number" class="text-right input-money" v-model="purchase.list[0].purchaseNet" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-short" v-model="purchase.list[0].originCountry" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0" class="input-short">{{getStockStateString(purchase.list[0].state)}}</td>
                <td v-if="purchase.list.length > 0"><input type="number" class="text-right input-money" v-model="purchase.list[0].salesPriceKrw" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0" class="input-short"><span v-if="purchase.list[0].awb.length > 0">{{purchase.list[0].awb}}</span><span v-if="purchase.list[0].awb.length == 0" v-on:click="getAWB(purchase.list[0], purchase)"><i class="fa fa-file"></i></span></td>
                <td v-if="purchase.list.length > 0"><input type="date" class="input-mid" v-model="purchase.list[0].dispatchDate" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0"><input type="number" class="text-right input-money" v-model="purchase.list[0].hsCode" @change="updateStock(purchase.list[0])" @keypress="onlyNumber" pattern="[0-9]*"/></td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-short" v-model="purchase.list[0].buyer" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-mid" v-model="purchase.list[0].contact" @change="updateStock(purchase.list[0])" @keypress="onlyNumber" pattern="[0-9]*"/></td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-short" v-model="purchase.list[0].customNumber" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0"><input type="number" class="text-right input-money" v-model="purchase.list[0].customValue" @change="updateStock(purchase.list[0])"/></td>
                <td v-if="purchase.list.length > 0" class="input-short" v-on:click="findAddress(purchase.list[0])">{{purchase.list[0].postCode}}</td>
                <td v-if="purchase.list.length > 0" class="text-left input-long">{{purchase.list[0].address}}</td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-long" v-model="purchase.list[0].address2" @change="updateStock(purchase.list[0])"/></td>


                <td v-if="purchase.list.length > 0"><span v-on:click="deleteStock(purchase.list[0])"><i class="fa fa-trash"></i></span></td>
              </tr>
              <tr v-for="(stock, childIndex) in purchase.list" v-if="childIndex > 0">

                <td>#{{stock.id}}</td>
                <td><span v-on:click="printItem(stock)"><i class="fa fa-barcode"></i></span></td>
                <td><input type="text" class="text-left input-long" v-model="stock.title" @keyup="checkSpecialCharacter(stock)" @change="updateStock(stock)"/></td>
                <td><input type="text" class="text-left input-long" v-model="stock.titleToSend" @keyup="checkSpecialCharacter(stock)" @change="updateStock(stock)"/></td>
                <td><input type="text" class="text-left input-long" v-model="stock.receiptItemTitle" @keyup="checkSpecialCharacter(stock)" @change="updateStock(stock)"/></td>
                <td><input type="text" class="text-left input-short" v-model="stock.colour" @keyup="checkSpecialCharacter(stock)" @change="updateStock(stock)"/></td>
                <td><input type="number" class="text-right input-money" v-model="stock.purchaseGross" @change="updateStock(stock)"/></td>
                <td><input type="number" class="text-right input-money" v-model="stock.purchaseVat" @change="updateStock(stock)"/></td>
                <td><input type="number" class="text-right input-money" v-model="stock.purchaseNet" @change="updateStock(stock)"/></td>
                <td><input type="text" class="text-left input-short" v-model="stock.originCountry" @change="updateStock(stock)"/></td>
                <td class="input-short">{{getStockStateString(stock.state)}}</td>
                <td v-if="purchase.list.length > 0"><input type="number" class="text-right input-money" v-model="stock.salesPriceKrw" @change="updateStock(stock)"/></td>
                <td v-if="purchase.list.length > 0" class="input-short"><span v-if="stock.awb.length > 0">{{stock.awb}}</span><span v-if="stock.awb.length == 0" v-on:click="getAWB(stock, purchase)"><i class="fa fa-file"></i></span></td>
                <td v-if="purchase.list.length > 0"><input type="date" class="input-mid" v-model="stock.dispatchDate" @change="updateStock(stock)"/></td>
                <td v-if="purchase.list.length > 0"><input type="number" class="text-right input-money" v-model="stock.hsCode" @change="updateStock(stock)" @keypress="onlyNumber" pattern="[0-9]*"/></td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-short" v-model="stock.buyer" @change="updateStock(stock)"/></td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-mid" v-model="stock.contact" @change="updateStock(stock)" @keypress="onlyNumber" pattern="[0-9]*"/></td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-short" v-model="stock.customNumber" @change="updateStock(stock)"/></td>
                <td v-if="purchase.list.length > 0"><input type="number" class="text-right input-money" v-model="stock.customValue" @change="updateStock(stock)"/></td>
                <td v-if="purchase.list.length > 0" class="input-short" v-on:click="findAddress(stock)">{{stock.postCode}}</td>
                <td v-if="purchase.list.length > 0" class="text-left input-long">{{stock.address}}</td>
                <td v-if="purchase.list.length > 0"><input type="text" class="text-left input-long" v-model="stock.address2" @change="updateStock(stock)"/></td>

                <td><span v-on:click="deleteStock(purchase.list[0])"><i class="fa fa-trash"></i></span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="form-container" v-if="editPurchaseItem!=false">
      <div class="form-inner-container">
        <div class="container">
          <div class="row">
            <div class="col-12">
              New Purchase
            </div>
          </div>


          <div class="row">
            <label class="col-4 form-control">Purchase Date</label>
            <input type="date" class="col-8 form-control" v-model="editPurchaseItem.purchasedTime"/>
          </div>
          <div class="row">
            <label class="col-4 form-control">Brand</label>
            <input type="text" class="col-8 form-control" v-model="editPurchaseItem.brand"/>
          </div>
          <div class="row">
            <label class="col-4 form-control">총금액</label>
            <input type="number" class="col-8 form-control" v-model="editPurchaseItem.gross" v-on:keyup="grossEntered"/>
          </div>
          <div class="row">
            <label class="col-4 form-control">NET</label>
            <input type="number" class="col-8 form-control" v-model="editPurchaseItem.net"/>
          </div>
          <div class="row">
            <label class="col-4 form-control">VAT</label>
            <input type="number" class="col-8 form-control" v-model="editPurchaseItem.vat"/>
          </div>
        </div>
        <div class="form-button-container">
          <div class="container">
            <div class="row">
              <div class="col-4">
                <button type="button" class="form-control btn btn-secondary" v-on:click="closePurchaseForm">닫기</button>
              </div>
              <div class="col-4">

              </div>
              <div class="col-4">
                <button type="button" class="form-control btn btn-primary" v-on:click="submitPurchaseForm">업데이트</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="form-container" v-if="editStockItem!=false">
      <div class="form-inner-container">
        <div class="container">
          <div class="row">
            <div class="col-12">
              물품추가
            </div>
          </div>


          <div class="row">
            <label class="col-4 form-control text-right">상품</label>
            <select class="col-4 form-control" v-model="selectedCategory" v-on:change="categorySelected">
              <option value="0">Select Category</option>
              <option v-for="(cat, index) in categories" :value="cat.id">{{cat.title}}</option>
            </select>
            <select class="col-4 form-control" v-model="selectedProduct" v-on:change="onProductSelected">
              <option value="-1">Select Product</option>
              <option v-for="(product, index) in products" :value="index">{{product.title}}</option>
            </select>

          </div>
          <div class="row">
            <label class="col-4 form-control text-right">COLOUR</label>
            <select class="col-8 form-control" v-model="editStockItem.colour">
              <option v-for="(colour, index) in editStockItem.colourOptions" :value="colour">{{colour}}</option>
            </select>
          </div>
          <div class="row">
            <label class="col-4 form-control text-right">상품명1 (품명)</label>
            <input type="text" class="col-8 form-control" v-model="editStockItem.productTitle"/>
          </div>
          <div class="row">
            <label class="col-4 form-control text-right">상품명2 (배송품명)</label>
            <input type="text" class="col-8 form-control" v-model="editStockItem.title"/>
          </div>
          <div class="row">
            <label class="col-4 form-control text-right">영수증 품명</label>
            <input type="text" class="col-8 form-control" v-model="editStockItem.receiptItemTitle"/>
          </div>
          <div class="row">
            <label class="col-4 form-control text-right">총금액</label>
            <input type="number" class="col-8 form-control" v-model="editStockItem.purchaseGross" v-on:keyup="stockGrossEntered"/>
          </div>

          <div class="row">
            <label class="col-4 form-control text-right">NET</label>
            <input type="number" class="col-8 form-control" v-model="editStockItem.purchaseNet"/>
          </div>
          <div class="row">
            <label class="col-4 form-control text-right">VAT</label>
            <input type="number" class="col-8 form-control" v-model="editStockItem.purchaseVat"/>
          </div>
          <div class="row">
            <label class="col-4 form-control text-right">개수</label>
            <input type="number" class="col-8 form-control" v-model="editStockItem.changeBalance"/>
          </div>
        </div>
        <div class="form-button-container">
          <div class="container">
            <div class="row">
              <div class="col-4">
                <button type="button" class="form-control btn btn-secondary" v-on:click="closeStockForm">닫기</button>
              </div>
              <div class="col-4">

              </div>
              <div class="col-4">
                <button type="button" class="form-control btn btn-primary" v-on:click="submitStockForm">업데이트</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spinner-container" v-if="isLoading">
      <div class="spinnermedium">
        <span class="bgtopl"><span class="highlighttopl"></span></span>
        <span class="bgtopr"><span class="highlighttopr"></span></span>
        <span class="bottomrow">
          <span class="bgbtml"><span class="highlightbtml"></span></span>
          <span class="bgbtmr"><span class="highlightbtmr"></span></span>
        </span>
      </div>
    </div>
    <div id="finder-container" class="fullscreen-container">
      <div id="postcodeFinderLayer" class="center-container">
        <img src="//t1.daumcdn.net/postcode/resource/images/close.png" id="btnCloseLayer"
             style="cursor:pointer;position:absolute;right:-3px;top:-3px;z-index:1" v-on:click="closeAddressFinder()"
             alt="닫기 버튼"/>
      </div>
    </div>
    <v-dialog width="500"/>
  </div>
</template>

<script>
    import axios from 'axios';
    import {updatePurchase, getPurchases, deletePurchase} from '../api/purchase'
    import {getCategories, updateProductItem, updateCategoryItem, getProductsByCategory, getCategoryById, getProductById, getProductStock, addStock, deleteStock} from '../api/product'

    import {millisToDate, millisToReadable, getStockTypeString, printLabel, getStockStateString} from '../api/utils'
    export default {
        name: "Purchase",
        data() {
            return {
                filter: {
                    from:0,
                    to:0,
                    state:0
                },
                editPurchaseItem:false,
                purchaseItems:[],
                editStockItem:false,


                categories:[],
                selectedCategory:0,
                products:[],
                selectedProduct:-1,

                printItems:[],

                isLoading:false,
                showAddressFinder: false,
            }
        },
        created() {
            let date = new Date();
            let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            this.$data.filter.from = millisToDate(firstDay.getTime(), '-');
            this.$data.filter.to = millisToDate(lastDay.getTime(), '-');
            this.getFilteredList();
            this.getCategoryList();
        },
        mounted() {
        },
        beforeDestroy() {
        },
        methods: {
            onlyNumber ($event) {
                //console.log($event.keyCode); //keyCodes value
                let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

                console.log("key code " + keyCode);
                if (keyCode < 48 || keyCode > 57 || keyCode == 46) { // 46 is dot
                    console.log("prevent");
                    return $event.preventDefault();
                }
                console.log("not prevent");
            },
            zeroPad: function(num, numZeros) {
                var n = Math.abs(num);
                var zeros = Math.max(0, numZeros - Math.floor(n).toString().length );
                var zeroString = Math.pow(10,zeros).toString().substr(1);
                if( num < 0 ) {
                    zeroString = '-' + zeroString;
                }

                return zeroString+n;
            },
            toDate: function(time) {
                return millisToDate(time);
            },
            showModal: function(title, message) {
                console.log("show modal " + title  + " : " + message);
                this.$modal.show('dialog',{
                    title: title,
                    text: message,
                    buttons:[
                        {title:'Close'}
                    ]
                })
                return;
            },
            getStockStateString: function(state) {
                return getStockStateString(state);
            },
            stockGrossEntered: function() {
                if( this.$data.editStockItem.purchaseGross.length == 0) {
                    this.$data.editStockItem.purchaseVat = 0;
                    this.$data.editStockItem.purchaseNet = 0;
                } else {
                    this.$data.editStockItem.purchaseVat = (this.$data.editStockItem.purchaseGross / 6).toFixed(2);
                    this.$data.editStockItem.purchaseNet = (this.$data.editStockItem.purchaseGross - this.$data.editStockItem.purchaseVat).toFixed(2);
                }
            },
            grossEntered: function() {
                if( this.$data.editPurchaseItem.gross.length == 0) {
                    this.$data.editPurchaseItem.vat = 0;
                    this.$data.editPurchaseItem.net = 0;
                } else {
                    this.$data.editPurchaseItem.vat = (this.$data.editPurchaseItem.gross / 6).toFixed(2);
                    this.$data.editPurchaseItem.net = (this.$data.editPurchaseItem.gross - this.$data.editPurchaseItem.vat).toFixed(2);
                }
            },
            getFilteredList: function() {
                let self = this;
                let fromTime = new Date(this.$data.filter.from);
                let toTime = new Date(this.$data.filter.to);

                getPurchases(fromTime.getTime(), toTime.getTime())
                    .then(function(data){
                        console.log("getPurchase List ");
                        console.log(data);
                        if(data.success == true) {
                            if(data.item.length > 0) {
                                for(let i = 0 ; i < data.item.length ; i++) {
                                    data.item[i].purchasedTime = millisToDate(data.item[i].purchasedTime, '-');
                                    data.item[i].gross = (data.item[i].gross/100).toFixed(2);
                                    data.item[i].net = (data.item[i].net/100).toFixed(2);
                                    data.item[i].vat = (data.item[i].vat/100).toFixed(2);
                                    if(data.item[i].list.length  > 0) {

                                        for(let j = 0 ; j < data.item[i].list.length ; j++) {

                                            data.item[i].list[j].purchaseGross = (data.item[i].list[j].purchaseGross/100).toFixed(2);
                                            data.item[i].list[j].purchaseNet = (data.item[i].list[j].purchaseNet/100).toFixed(2);
                                            data.item[i].list[j].purchaseVat = (data.item[i].list[j].purchaseVat/100).toFixed(2);
                                        }
                                    }
                                }
                                self.$data.purchaseItems = data.item;
                            }
                        } else {

                        }
                    })
                    .catch(function(err) {
                        console.log("Error to get purchase list " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            openPurchaseForm: function(index) {
                if(index >= 0) {
                    this.$data.editPurchaseItem = JSON.parse(JSON.stringify(this.$data.purchaseItems[index]))
                    this.$data.editPurchaseItem.gross = (this.$data.editPurchaseItem.gross /100).toFixed(2);
                    this.$data.editPurchaseItem.net = (this.$data.editPurchaseItem.net /100).toFixed(2);
                    this.$data.editPurchaseItem.vat = (this.$data.editPurchaseItem.vat /100).toFixed(2);
                } else {
                    let today = new Date();
                    this.$data.editPurchaseItem = {
                        id:0,
                        title:"",
                        type:"",
                        gross:0,
                        vat:0,
                        net:0,
                        brand:"",
                        purchasedTime:millisToDate(today.getTime(), '-'),
                    }
                }
            },
            closePurchaseForm: function() {
                this.$data.editPurchaseItem = false;
            },

            deletePurchaseItem: function(purchaseItem) {

                console.log("deletePurchaseItem ");
                console.log(purchaseItem);
                let self = this;
                deletePurchase(purchaseItem.id)
                    .then(function(data) {
                        if (data.success == true) {
                            for(let i = 0 ; i < self.$data.purchaseItems.length ; i++) {
                                if(self.$data.purchaseItems[i].id == data.item.id) {
                                    console.log("Delete now");
                                    self.$data.purchaseItems.splice(i, 1);
                                }
                            }

                        }
                    })
                    .catch(function(err) {
                        console.log("Delete purchase item ERR " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            updatePurchaseItem: function(updateItem) {
                let purchaseItem = JSON.parse(JSON.stringify(updateItem));
                delete purchaseItem.list;
                purchaseItem.gross = (purchaseItem.gross*100).toFixed(0);
                purchaseItem.net = (purchaseItem.net*100).toFixed(0);
                purchaseItem.vat = (purchaseItem.vat*100).toFixed(0);
                let day = new Date(purchaseItem.purchasedTime);
                purchaseItem.purchasedTime = day.getTime();

                console.log("updatePurchaseItem ");
                console.log(purchaseItem);
                let self = this;
                updatePurchase(purchaseItem)
                    .then(function(data) {
                        if (data.success == true) {
                            for(let i = 0 ; i < self.$data.purchaseItems.length ; i++) {
                                if(self.$data.purchaseItems[i].id == data.item.id) {
                                    console.log("Replace now");
                                    data.item.gross = (data.item.gross/100).toFixed(2);
                                    data.item.net = (data.item.net/100).toFixed(2);
                                    data.item.vat = (data.item.vat/100).toFixed(2);
                                    data.item.list = self.$data.purchaseItems[i].list;
                                    data.item.purchasedTime = millisToDate(data.item.purchasedTime, '-');
                                    self.$data.purchaseItems.splice(i, 1, data.item);
                                }
                            }

                        }
                    })
                    .catch(function(err) {
                        console.log("Update purchase item ERR " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            submitPurchaseForm: function() {
                let self = this;
                console.log("DATE: " + this.$data.editPurchaseItem.purchasedTime);

                if(this.$data.editPurchaseItem.purchasedTime.length == 0 || this.$data.editPurchaseItem.purchasedTime == '0000-00-00') {
                    this.showModal("ERROR", "구매일을 입력하세요");
                    return;
                }
                let date = new Date(this.$data.editPurchaseItem.purchasedTime);
                this.$data.editPurchaseItem.purchasedTime = date.getTime();
                console.log("DATE time " + this.$data.editPurchaseItem.purchasedTime);
                if(this.$data.editPurchaseItem.brand.length == 0) {
                    this.showModal("ERROR", "브랜드를 입력하세요");
                    return;
                }
                if(this.$data.editPurchaseItem.gross.length == 0 || this.$data.editPurchaseItem.gross == 0) {
                    this.showModal("ERROR", "가격을 입력하세요");
                    return;
                }
                this.$data.editPurchaseItem.gross = (this.$data.editPurchaseItem.gross * 100).toFixed(0);
                this.$data.editPurchaseItem.net = (this.$data.editPurchaseItem.net * 100).toFixed(0);
                this.$data.editPurchaseItem.vat = (this.$data.editPurchaseItem.vat * 100).toFixed(0);

                updatePurchase(this.$data.editPurchaseItem)
                    .then(function(data) {
                        self.$data.editPurchaseItem = false;
                        if(data.success == true) {

                            data.item.purchasedTime = millisToDate(data.item.purchasedTime, '-');
                            data.item.gross = (data.item.gross / 100).toFixed(2);
                            data.item.net = (data.item.net / 100).toFixed(2);
                            data.item.vat = (data.item.vat / 100).toFixed(2);
                            if(self.$data.purchaseItems.length > 0) {
                                for(let i = 0 ; i < self.$data.purchaseItems.length ; i++) {
                                    if(self.$data.purchaseItems[i].id == data.item.id) {
                                        self.$data.purchaseItems.splice(i, 1, data.item);
                                        return;
                                    }
                                }
                            }

                            self.$data.purchaseItems.push(data.item);
                        }
                    })
                    .catch(function(err){
                        self.$data.editPurchaseItem = false;
                        console.log("submitPurchaseItem err " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },


            openStockForm: function(purchaseIndex, stockIndex) {
                if(purchaseIndex < 0) {
                    return;
                }

                if(stockIndex >= 0) {
                    this.$data.editStockItem = JSON.parse(JSON.stringify(this.$data.purchaseItems[purchaseIndex].list[stockIndex]));
                    this.$data.editStockItem.purchaseGross = (this.$data.editStockItem.purchaseGross/100).toFixed(2);
                    this.$data.editStockItem.purchaseNet = (this.$data.editStockItem.purchaseNet/100).toFixed(2);
                    this.$data.editStockItem.purchaseVat = (this.$data.editStockItem.purchaseVat/100).toFixed(2);
                } else {
                    this.$data.editStockItem = {
                        id:0,
                        productId:0,
                        purchaseId:this.$data.purchaseItems[purchaseIndex].id,
                        type:'stock_in',
                        changeType:'purchase',
                        purchaseGross:0,
                        purchaseVat:0,
                        purchaseNet:0,
                        brand:this.$data.purchaseItems[purchaseIndex].brand,
                        titleToSend:'',
                        receiptItemTitle:'',
                        productTitle:'',
                        changeBalance:1,
                        title:'',
                        inTime:this.$data.purchaseItems[purchaseIndex].purchasedTime,

                        color:'select',
                    }
                }
                this.$data.editStockItem.colourOptions = ['select'];



            },
            closeStockForm: function() {
                this.$data.editStockItem = false;
            },

            getAWB: function(stockItem, purchaseItem) {
                if(stockItem.dispatchDate == '') {
                    this.showModal("", "보내는날 필요합니다");
                    return;
                }
                if(stockItem.hsCode == '' || stockItem.hsCode == 0) {
                    this.showModal("", "HS Code가 필요합니다");
                    return;
                }
                if(stockItem.buyer == '' || stockItem.buyer.length == 0) {
                    this.showModal("", "수취인이 필요합니다");
                    return;
                }
                if(stockItem.contact == '' || stockItem.contact.length == 0) {
                    this.showModal("", "수취인 연락처가 필요합니다");
                    return;
                }
                if(stockItem.customNumber == '' || stockItem.customNumber.startsWith("P") == false) {
                    this.showModal("", "개인통관번호가 필요합니다");
                    return;
                }
                if(stockItem.salesPriceKrw === '' || stockItem.salesPriceKrw === 0) {
                    this.showModal("", "판매가 (한화) 입력해주세요");
                    return;
                }
                if(stockItem.customValue == '' || stockItem.customValue == 0) {
                    this.showModal("", "단가가 필요합니다");
                    return;
                }
                if(stockItem.postCode == "" || stockItem.postCode.length == 0) {
                    this.showModal("", "주소가 필요합니다");
                    return;
                }
                if(stockItem.address == "" || stockItem.address.length == 0) {
                    this.showModal("", "주소가 필요합니다");
                    return;
                }
                if(stockItem.titleToSend === "" || stockItem.titleToSend.length == 0) {
                    this.showModal("", "배송용 상품명을 입렵해주세요");
                    return;
                }
                if(stockItem.originCountry === "" || stockItem.originCountry.length == 0 ) {
                    this.showModal("", "원산지를 입렵해주세요");
                    return;
                }


                let key = "fwlineurfenrjfer7r34iuhr23r892rhwhef";
                let code = "SOON";

                let productItem = {
                    "product": stockItem.titleToSend,
                    "brand": purchaseItem.brand,
                    "amount": 1,
                    "value": stockItem.customValue,



                }


                let list = [
                    {
                        "product": stockItem.titleToSend,
                        "brand": purchaseItem.brand,
                        "amount": 1,
                        "value": stockItem.customValue,
                        "hs_code":stockItem.hsCode,
                        "site_url": purchaseItem.brand,
                        "origin_country": "UK",

                    }
                ];

                let item = {
                    receiver: stockItem.buyer,
                    receiver_contact: stockItem.contact,
                    address_1: stockItem.address,
                    address_2: stockItem.address2,
                    post_code: stockItem.postCode,
                    custom_number: stockItem.customNumber,
                    ct:1,
                    value:stockItem.customValue,
                    seller_type:2,
                    custom_type:'목',
                    trade_type:'A',
                    dispatch_date:stockItem.dispatchDate,
                    who_pays_tax: 1,
                    who_pays_inspection:1,
                    forwarder_id:1,
                    list: JSON.stringify(list),
                };
                console.log("data " + JSON.stringify(item));
                this.$data.isLoading = true;
                let self = this;
                axios.post(process.env.UTASCO_API + 'app_add_item.php', JSON.stringify(item), {
                    headers:{
                        "code": code,
                        "apiKey": key,
                        "Content-Type": "application/json"
                    }
                })
                    .then(function(res){
                        self.$data.isLoading = false;
                        //data = data.response;
                        let data = res.data;
                        console.log(data);
                        if(data.success == true) {
                            if(data.item != undefined) {
                                console.log("AWB acquired " + data.item.awb);
                                stockItem.awb = data.item.awb;

                                self.updateStock(stockItem);
                            } else {
                                console.log("item is not defined");
                            }
                        } else {
                            console.log("Success is not true")
                        }
                    })
                    .catch(function(err) {
                        self.$data.isLoading = false;
                        console.log("Failed to create AWB "+ err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            checkSpecialCharacter: function(stockItem) {
                if (stockItem.title.includes('"') || stockItem.title.includes("'")) {
                    this.showModal("에러", "특수문자는 사용할수 없습니다");
                    stockItem.title = stockItem.title.replace(/[^a-zA-Z ]/g, "");
                    return;
                }
                if (stockItem.titleToSend.includes('"') || stockItem.titleToSend.includes("'")) {
                    this.showModal("에러", "특수문자는 사용할수 없습니다");
                    stockItem.titleToSend = stockItem.titleToSend.replace(/[^a-zA-Z ]/g, "");
                    return;
                }
                if (stockItem.receiptItemTitle.includes('"') || stockItem.receiptItemTitle.includes("'")) {
                    this.showModal("에러", "특수문자는 사용할수 없습니다");
                    stockItem.receiptItemTitle = stockItem.receiptItemTitle.replace(/[^a-zA-Z ]/g, "");
                    return;
                }
                if (stockItem.colour.includes('"') || stockItem.colour.includes("'")) {
                    this.showModal("에러", "특수문자는 사용할수 없습니다");
                    stockItem.colour = stockItem.colour.replace(/[^a-zA-Z ]/g, "");
                    return;
                }

            },
            deleteStock: function(stockItem) {
                stockItem.purchaseGross = (stockItem.purchaseGross*100).toFixed(0);
                stockItem.purchaseNet = (stockItem.purchaseNet*100).toFixed(0);
                stockItem.purchaseVat = (stockItem.purchaseVat*100).toFixed(0);
                stockItem.deleted = true;
                let self = this;
                deleteStock(stockItem.id)
                    .then(function(data) {
                        console.log(data);
                        if (data.success == true) {
                            console.log("updated stock");
                            console.log(data.item);
                            data.item.purchaseGross = (data.item.purchaseGross/100).toFixed(2);
                            data.item.purchaseNet = (data.item.purchaseNet/100).toFixed(2);
                            data.item.purchaseVat = (data.item.purchaseVat/100).toFixed(2);
                            console.log("updated stock reset price");

                            for(let p = 0 ; p < self.$data.purchaseItems.length ; p++ ) {
                                if(self.$data.purchaseItems[p].id == data.item.purchaseId) {
                                    for(let i = 0 ; i < self.$data.purchaseItems[p].list.length ; i++ ) {
                                        if(self.$data.purchaseItems[p].list[i].id == data.item.id) {
                                            self.$data.purchaseItems[p].list.splice(i, 1);
                                        }
                                    }
                                }
                            }
                            stockItem = data.item;

                            console.log(stockItem);
                        }
                    })
                    .catch(function(err) {
                        console.log("Failed to update Stock " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            updateStock:function(stockItem) {

                stockItem.purchaseGross = (stockItem.purchaseGross*100).toFixed(0);
                stockItem.purchaseNet = (stockItem.purchaseNet*100).toFixed(0);
                stockItem.purchaseVat = (stockItem.purchaseVat*100).toFixed(0);
                stockItem.changeBalance = 1;


                if (stockItem.title.includes('"') || stockItem.title.includes("'")) {
                    //this.showModal("에러", "특수문자는 사용할수 없습니다");
                    stockItem.title = stockItem.title.replace(/[^a-zA-Z ]/g, "");
                }
                if (stockItem.titleToSend.includes('"') || stockItem.titleToSend.includes("'")) {
                    // this.showModal("에러", "특수문자는 사용할수 없습니다");
                    stockItem.titleToSend = stockItem.titleToSend.replace(/[^a-zA-Z ]/g, "");
                }
                if (stockItem.receiptItemTitle.includes('"') || stockItem.receiptItemTitle.includes("'")) {
                    // this.showModal("에러", "특수문자는 사용할수 없습니다");
                    stockItem.receiptItemTitle = stockItem.receiptItemTitle.replace(/[^a-zA-Z ]/g, "");
                }
                if (stockItem.colour.includes('"') || stockItem.colour.includes("'")) {
                    // this.showModal("에러", "특수문자는 사용할수 없습니다");
                    stockItem.colour = stockItem.colour.replace(/[^a-zA-Z ]/g, "");
                }
                let self = this;
                console.log("submit stock item");
                console.log(stockItem);
                addStock(stockItem)
                    .then(function(data) {
                        console.log(data);
                        if (data.success == true) {
                            console.log("updated stock");
                            console.log(data.item);
                            data.item.purchaseGross = (data.item.purchaseGross/100).toFixed(2);
                            data.item.purchaseNet = (data.item.purchaseNet/100).toFixed(2);
                            data.item.purchaseVat = (data.item.purchaseVat/100).toFixed(2);
                            console.log("updated stock reset price");

                            for(let p = 0 ; p < self.$data.purchaseItems.length ; p++ ) {
                                if(self.$data.purchaseItems[p].id == data.item.purchaseId) {
                                    for(let i = 0 ; i < self.$data.purchaseItems[p].list.length ; i++ ) {
                                        if(self.$data.purchaseItems[p].list[i].id == data.item.id) {
                                            self.$data.purchaseItems[p].list.splice(i, 1, data.item);
                                        }
                                    }
                                }
                            }
                            stockItem = data.item;

                            console.log(stockItem);
                        }
                    })
                    .catch(function(err) {
                        console.log("Failed to update Stock " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            submitStockForm: function() {

                let stockItem = JSON.parse(JSON.stringify(this.$data.editStockItem));
                stockItem.purchaseGross = (this.$data.editStockItem.purchaseGross*100).toFixed(0);
                stockItem.purchaseNet = (this.$data.editStockItem.purchaseNet*100).toFixed(0);
                stockItem.purchaseVat = (this.$data.editStockItem.purchaseVat*100).toFixed(0);
                stockItem.changeBalance = 1;
                let date = new Date(stockItem.inTime);
                stockItem.inTime = date.getTime();
                let self = this;
                console.log("submit stock item");
                console.log(stockItem);
                addStock(stockItem)
                    .then(function(data) {
                        console.log(data);
                        if(data.success == true) {
                            // self.addLabelItem(data.item.productId,
                            //     data.item.id,
                            //     data.item.title,
                            //     data.item.colour,
                            //     self.$data.products[self.$data.selectedProduct].brand,
                            //     self.$data.products[self.$data.selectedProduct].price)
                            for(let i = 0 ; i < self.$data.purchaseItems.length ;  i++) {
                                if(self.$data.purchaseItems[i].id == data.item.purchaseId) {
                                    data.item.purchaseGross = (data.item.purchaseGross/100).toFixed(2);
                                    data.item.purchaseNet = (data.item.purchaseNet/100).toFixed(2);
                                    data.item.purchaseVat = (data.item.purchaseVat/100).toFixed(2);
                                    self.$data.purchaseItems[i].list.push(data.item);
                                    break;
                                }
                            }
                            self.$data.editStockItem.changeBalance--;
                            if(self.$data.editStockItem.changeBalance <= 0) {
                                self.$data.editStockItem = false;
                                self.printLabelItems();
                            } else {
                                self.submitStockForm();
                            }

                        }

                    })
                    .catch(function(err) {
                        console.log("submit stock error " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })

            },

            getCategoryList: function() {
                let self = this;

                getCategories()
                    .then(function(data){
                        if(data.success == true) {
                            self.$data.categories = data.item;
                        }
                    })
                    .catch(function(err) {
                        console.log("getCategoryList err " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },

            categorySelected: function() {
                this.$data.products = [];
                this.$data.selectedProduct = -1;
                if(this.$data.selectedCategory <= 0) {
                    this.$data.products = [];
                    return;
                }
                this.getProductList(this.$data.selectedCategory);


            },
            getProductList: function(cid) {
                let self = this;
                getProductsByCategory(cid)
                    .then(function(data) {
                        if(data.success == true) {
                            self.$data.products = data.item;
                        }
                    })
                    .catch(function(err) {
                        console.log("getProduct List err " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            onProductSelected: function() {
                console.log("onProductSelected " + this.$data.selectedProduct);
                if(this.$data.selectedProduct == -1) {
                    this.$data.editStockItem.title = "";
                    this.$data.editStockItem.productId = 0;
                    this.$data.editStockItem.colourOptions = [];
                    this.$data.editStockItem.colour = 'select';
                    return;
                }

                this.$data.editStockItem.title = this.$data.products[this.$data.selectedProduct].title;
                this.$data.editStockItem.productId = this.$data.products[this.$data.selectedProduct].id;
                console.log(this.$data.editStockItem);
                if(this.$data.products[this.$data.selectedProduct].colours != null &&
                    this.$data.products[this.$data.selectedProduct].colours.length > 0) {
                    this.$data.editStockItem.colourOptions = this.$data.products[this.$data.selectedProduct].colours.split(',');
                }
                this.$data.editStockItem.colourOptions.unshift("select");
                this.$data.editStockItem.colour = 'select';
            },
            addLabelItem(productId, stockId, productTitle, description, brand, price) {

                for(let i = 0 ; i < this.$data.printItems.length ; i++) {
                    if(this.$data.printItems[i].pid == productId &&
                        this.$data.printItems[i].title === productTitle &&
                        this.$data.printItems[i].description === description &&
                        this.$data.printItems[i].brand === brand &&
                        this.$data.printItems[i].price === price) {
                        this.$data.printItems[i].barcode += ",4700" + this.zeroPad(productId, 8) + this.zeroPad(stockId, 8)
                        return;
                    }
                }

                let item = {
                    barcode: "4700" + this.zeroPad(productId, 8) + this.zeroPad(stockId, 8),
                    pid: productId,
                    stockId: stockId,
                    title: productTitle,
                    description: description,
                    brand: brand,
                    price: price,
                }
                this.$data.printItems.push(item);
            },
            printItem: function(stock) {
                console.log("printItem");
                console.log(stock);
            },
            printLabelItems: function() {
                if(this.$data.printItems.length == 0) {
                    return;
                }

                let title = "";

                //let barcode = "4700" + this.zeroPad(this.$data.printItems[0].pid, 8) + this.zeroPad(this.$data.printItems[0].stockId, 8);

                let self = this;
                this.$data.isLoading = true;
                printLabel(this.$data.printItems[0].barcode, this.$data.printItems[0].title, this.$data.printItems[0].brand, this.$data.printItems[0].price.toFixed(2))
                    .then(function(data){
                        self.$data.isLoading = false;
                        if(data.success) {
                            self.$data.printItems.splice(0, 1);
                            self.printLabelItems();
                        } else {
                            console.log("Printer returned false");
                        }
                    })
                    .catch(function(err){
                        self.$data.isLoading = false;
                        console.log("PRinter err " + err);
                        if(err.response != undefined) {
                            console.log(err.response)
                        }
                    })


            },
            findAddress: function (stockItem) {
                this.$data.showAddressFinder = true;
                var self = this;
                new daum.Postcode({
                    oncomplete: function (data) {
                        // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

                        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
                        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
                        console.log(data);
                        var addr = ''; // 주소 변수
                        var extraAddr = ''; // 참고항목 변수

                        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
                        if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                            addr = data.roadAddress;
                        } else { // 사용자가 지번 주소를 선택했을 경우(J)
                            addr = data.jibunAddress;
                        }

                        // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
                        if (data.userSelectedType === 'R') {
                            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
                            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
                            if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
                                extraAddr += data.bname;
                            }
                            // 건물명이 있고, 공동주택일 경우 추가한다.
                            if (data.buildingName !== '') {
                                extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
                            }
                            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
                            if (extraAddr !== '') {
                                extraAddr = ' (' + extraAddr + ')';
                            }
                            // 조합된 참고항목을 해당 필드에 넣는다.
                            //document.getElementById("sample2_extraAddress").value = extraAddr;

                        } else {
                            //document.getElementById("sample2_extraAddress").value = '';
                        }

                        // 우편번호와 주소 정보를 해당 필드에 넣는다.
                        stockItem.postCode = data.zonecode;
                        stockItem.address = addr;
                        if (extraAddr !== '') {
                            stockItem.address += extraAddr;
                        }
                        //self.$data.basketPageDeliveryInfoEdit = true;
                        //document.getElementById('sample2_postcode').value = data.zonecode;
                        //document.getElementById("sample2_address").value = addr;
                        // 커서를 상세주소 필드로 이동한다.
                        //document.getElementById("sample2_detailAddress").focus();

                        // iframe을 넣은 element를 안보이게 한다.
                        // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
                        self.$data.showAddressFinder = false;
                        $("#finder-container").css('display', 'none');
                        $("#postcodeFinderLayer").css('display', 'none');
                        self.updateStock(stockItem);

                    },
                    width: '100%',
                    height: '100%',
                    maxSuggestItems: 5
                }).embed(document.getElementById('postcodeFinderLayer'));

                // iframe을 넣은 element를 보이게 한다.
                $("#finder-container").css('display', 'block');
                $("#postcodeFinderLayer").css('display', 'block');
            },
            closeAddressFinder: function () {
                this.$data.showAddressFinder = false;
                $("#finder-container").css('display', 'none');
                $("#postcodeFinderLayer").css('display', 'none');
            },

        }
    }
</script>

<style lang="css" scoped>

  .form-container {
    position: absolute;
    background: rgba(0,0,0,0.4);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10002;
  }
  .form-inner-container {
    position: absolute;
    width: 80%;
    height: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: white;
    padding:50px;
    padding-bottom:70px;
    overflow-y: scroll;
  }
  .form-button-container {
    position: sticky;
    bottom:-70px;
    left: 0;
    width: 100%;
    padding:20px;
    background: white;
  }
  label.form-control {
    border:none;
  }

  .purchase-table-header {
    border-top: 2px solid black;
    border-bottom: 2px solid black;
  }
  .purchase-block {
    border-bottom: 2px solid black;
  }

  .horizontal-scrollable {
    overflow-x: scroll;
  }
  .input-long {
    min-width: 300px;
    width:300px;
  }
  .input-money {
    min-width: 100px;
    width:100px;
  }
  .input-mid {
    min-width: 200px;
    width:200px;
  }
  .input-short {
    min-width: 100px;
    width:100px;
  }
  .table td, th {
    padding:0.25rem;
  }
  .fullscreen-container {
    display: none;
    background-color: rgb(0,0,0,0.8);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
  }
  .center-container {
    width: 90%;
    height: 90%;
    display:none;
    position:relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow:hidden;
    -webkit-overflow-scrolling:touch;
  }
  .fa, .fas {
    padding-left: 10px;
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Purchase.vue